var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MainLayout',{scopedSlots:_vm._u([{key:"content",fn:function(){return [(!_vm.IS_LOADING.status)?_c('div',{staticClass:"content-container flex flex-col w-full px-8"},[_c('Header1',{attrs:{"label":"Global Settings"}}),_c('PayoutForm',{attrs:{"data":_vm.GLOBAL_SETTING},on:{"onSubmit":_vm.onSubmit}})],1):_vm._e()]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }